"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
const basic_http_1 = __importDefault(require("../util/basic-http"));
const analytics_data_1 = require("./analytics-data");
const google_analytics_1 = require("./google/google-analytics");
class Analytics {
    constructor(applicationID) {
        this._pageTime = null;
        this.origin = "production";
        this.event = "track";
        /**
         * Use HTTP Request to write analytics, otherwise will use beacons
         */
        this.isBeacon = false;
        this._applicationID = applicationID;
        this._data = new analytics_data_1.AnalyticsData();
        this._ga = new google_analytics_1.GoogleAnalytics();
        this._handlePageHide = () => {
            if (document.visibilityState === "hidden") {
                this._pageTime = new Date();
            }
            else if (this._pageTime) {
                const time2 = new Date();
                const diff = time2.getTime() - this._pageTime.getTime();
                const data = this.data;
                data.push("eventAction", "View Time");
                data.push("viewTime", diff);
                data.push("eventLabel", diff);
                this.write();
                this._pageTime = null;
                document.removeEventListener("visibilitychange", this._handlePageHide, false);
            }
        };
    }
    get googleAnalytics() {
        return this._ga;
    }
    query(query = null) {
        return new Promise((accept, reject) => {
            if (!query) {
                return reject(new Error("Analytics.query() - provided query was null"));
            }
            const url = this.origin === "dev" ? "https://localhost:3008/v3/read" : "https://analytics.plattar.com/v3/read";
            const data = {
                data: {
                    attributes: {
                        application_id: this._applicationID,
                        event: this.event,
                        query: query
                    }
                }
            };
            basic_http_1.default.exec("POST", url, data).then((result) => {
                accept(result ? result : {});
            }).catch(reject);
        });
    }
    write() {
        return new Promise((accept, reject) => {
            const data = this._data;
            const url = this.origin === "dev" ? "https://localhost:3008/v3/write" : "https://analytics.plattar.com/v3/write";
            data.push("applicationId", this._applicationID);
            const sendData = {
                data: {
                    attributes: {
                        application_id: this._applicationID,
                        event: this.event,
                        origin: this.origin,
                        fields: data.data
                    }
                }
            };
            if (this.isBeacon === false) {
                basic_http_1.default.exec("POST", url, sendData).then((result) => {
                    accept(result ? result : {});
                }).catch(reject);
            }
            else {
                basic_http_1.default.execBeacon(url, sendData).then((result) => {
                    accept(result ? result : {});
                }).catch(reject);
            }
            this.googleAnalytics.write(this.event, this.data);
        });
    }
    startRecordEngagement() {
        document.addEventListener("visibilitychange", this._handlePageHide, false);
    }
    get data() {
        return this._data;
    }
}
exports.Analytics = Analytics;
